import { TextareaHTMLAttributes, forwardRef, useEffect, useRef, useState } from 'react';
import classNames from '@/lib/classNames';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, placeholder, ...props }) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const [textareaHeight, setTextareaHeight] = useState<string>('10px');

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = '10px'; // Reset the height
            //If the text area spans more than one line, set the height to the scroll height + 5px
            const textAreaHeight = textareaRef?.current && textareaRef.current?.scrollHeight + (textareaRef.current?.scrollHeight > 50 ? 5 : 0);
            textareaRef.current.style.height = `${textAreaHeight}px`; // Set the height based on content
            setTextareaHeight(`${textareaRef.current.style.height}`);
        }
    }, [props.value]); // Listen for changes in the textarea content

    return (
        <>
            <textarea
                ref={(el) => {
                    textareaRef.current = el;
                }}
                placeholder={placeholder}
                style={{
                    height: textareaHeight,
                    overflow: 'hidden',
                    resize: 'none',
                }}
                className={classNames(
                    'flex p text-primary w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-input disabled:border-input disabled:text-muted-foreground',
                    className
                )}
                {...props}
            />
        </>
    );
});

Textarea.displayName = 'Textarea';

export { Textarea };
